export default "__VITE_ASSET__C3ohfv3b__"